import { TAppearanceId } from "./appearance";
import { IClub, TClubId } from "./club";
import { TComment } from "./comment";
import { THaircut } from "./haircut";
import { ILangModel, TLangModelId } from "./lang";
import { IService, TServiceId } from "./service";

/**
 * @type string
 * @format email
 */
export type TEmail = string | null;

export type TUserType = "model" | "client" | "admin";

export const USER_TYPES: { id: number; name: Exclude<TUserType, "admin"> }[] = [
  {
    id: 1,
    name: "client",
  },
  {
    id: 2,
    name: "model",
  },
];

export type TGender = "M" | "F";

export type TVerify = "pending" | "approved" | "rejected";

export type IPhoto = {
  photoUrl: string;
  id: number;
};

export type TBustSize = "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H";

export type TDataValues = {
  phone: string | null;
  description: string | null;
  city: string | null;
  zipIndex: string | null;
  birthDate: string | null;
  createdAt: Date;
  height: number;
  weight: number;
  breast: TBustSize | null;
  haircutId: string | null;
};

export interface IModelData {
  age: string;
  dataValues: TDataValues;
}

export interface IUserData {
  usersClubs: { clubId: TClubId; club: IClub[] }[];
  createdAt: Date;
  email: TEmail;
  firstName: string;
  gallery: IPhoto[];
  gender: TGender | null;
  id: number;
  isVerify: TVerify | null;
  language: ILangModel[];
  lastName: string;
  model: null | IModelData; // ??
  profileAvatar: {
    id: number | null;
    avatarUrl: string | null;
    // "appearance": {
    //   "appearance": "Asian"
    // }
  } | null;
  service: IService[];
  type: TUserType;
  updatedAt: Date;
  username: string;
  usersAppearances: {
    appearanceId: TAppearanceId;
    // "appearance": {
    //   "appearance": "Asian"
    // }
  }[];
  comments: TComment[];
  Haircut: THaircut[];
}

export interface IRegisterData {
  password: string;
  username: string;
  email: TEmail;
  firstName: string;
  lastName: string;
  type: string;
}

export interface ILoginData {
  username: string;
  password: string;
}

export interface IResponseGetUsers {
  id: number;
  firstName: string;
  lastName: string;
  phone: string | null;
  city: string | null;
  zipIndex: string | null;
  age: number | null;
  height: number | null;
  weight: number | null;
  breast: null | TBustSize;
  avatarUrl: null | string;
  services: { id: TServiceId; serviceName: string }[];
}

export interface IRequestPatchUser {
  firstName?: string;
  lastName?: string;
  gender?: TGender;
  email?: TEmail;
  username?: string;
  model?: {
    phone?: string;
    description?: string;
    city?: string;
    zipIndex?: number;
    birthDate?: string; //format '10.10.2010'
    height?: number;
    weight?: number;
    breast?: string;
  };
  profileAvatar?: {
    avatarUrl?: string | null; //base64
    onDoubleTap?: boolean;
  };
  gallery?: string[]; //base64
  usersAppearances?: { appearanceId: TAppearanceId }[];
  usersClubs?: { clubId: TClubId }[];
  language?: { languageId: TLangModelId }[];
  service?: { serviceId: TServiceId }[];
  Haircut?: THaircut;
}
